<template>
  <div class="container-fluid mt-3">
    <form @submit.prevent="updateNames" >
      <div class="row">
        <div class="col-md-6 col-sm-12">

          <div class="form-group" v-if="errors.length" >
            <ul class="list-group">
              <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </div>

          <div class="form-group input-group-sm">
            <label>Nazwa produktu</label>
            <input type="text"
              class="form-control mb-3"
              placeholder="Szukaj"
              v-model="searchFilter"
              @keyup="onFilterChange">
            <select multiple class="form-control select-size" v-model="oldProductNames" style="height:200px">
              <option v-for="option in productNames" :key="option" v-bind:value="option" >
                {{ option }}
              </option>
            </select>
          </div>

          <div class="form-group input-group-sm">
            <label>Nowa nazwa produktu</label>
            <input class="form-control" type="text" v-model="updateProductData.newProductName">
          </div>

          <div class="form-group input-group-sm">
            <input class="btn btn-success btn-sm mr-2 torre-btn" type="submit" value="Zapisz">
          </div>

        </div>
      </div>
    </form>
  </div>
</template>
<script>
import autoComplete from "js-autocomplete"
import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import MainPresenter from "@/service/MainPresenter"
import validator from 'validator'
import un from 'underscore'
import uns from "underscore.string"
import priceUtils from "@/utils/PriceUtils"

export default {
  name: "",
  data: () => ({
    mainPresenter: new MainPresenter(),
    searchFilter:"",
    oldProductNames: [],
    errors: [],
    productNames: [],
    productNamesCpy: [],
    selectedStores: [],
    productPrice: 0,
    selectedProductNames: [],
    updateProductData: {
      oldProductName: "",
      newProductName: ""
    },
  }),
  created() {

  },
  mounted() {
    this.loadProductNames();
  },
  methods: {
    filterNames: function () {
      if (validator.isEmpty(this.searchFilter)) {
        this.productNames = this.productNamesCpy;
        return;
      }
      this.productNames = un.filter(this.productNamesCpy, item => {
        return uns.include(item.toLowerCase(), this.searchFilter.toLowerCase());
      });
    },
    onFilterChange: un.debounce(function (e) {
      this.filterNames();
    }, 150),
    updateNames: function() {
      this.errors = []
      var err = this.validate()
      if (err.length > 0) {
        this.errors = err
        return false
      }
      this.updateProductData.oldProductName = this.oldProductNames[0]
      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + '/updateProductsName',
        data: this.updateProductData,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.$router.push({name: 'main'})
      }).catch(err => {
        console.log(err);
        this.errors = un.map(err.response.data.errors, item => {
          return item.defaultMessage
        })
      })
    },
    validate () {
      var err = []
      var pn = this.oldProductNames[0] || ""
      if (validator.isEmpty(pn)) {
        err.push('Podaj nazwe produktu')
      }
      if (validator.isEmpty(this.updateProductData.newProductName)) {
        err.push('Podaj nową nazwe produktu')
      }
      if (!un.contains(this.productNames, pn)) {
        err.push('Nie ma takiej nazwy produktu')
      }
      return err
    },
    loadProductNames: function () {
      const req = axios({
        method: 'get',
        url: appConfig.baseUrl + "/product/allNames",
        headers: {
          Authorization: userService.getAuthHeader()
        }
      });
      req.then(res => {
        this.productNames = res.data
        this.productNamesCpy = res.data
      }).catch(_ => {
        console.log("err");
      })
    },
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/product-names/EditProductNames.vue